// @core/api/endpoints/knowledge/delete_knowledge_base.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/knowledge';

/**
 * Delete knowledge base
 * Deletes a knowledge base together with all its sources and chunks. Source content itself (documents) is not touched.
 */
export async function DeleteKnowledgeBase(
  base_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/knowledge/bases/:base_id`;
  requestPath = requestPath.replace(':base_id', encodeURIComponent(base_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
